export const POS_PLATFORM_LOADING = "POS_PLATFORM_LOADING";
export const POS_PLATFORM_CONFIG = "POS_PLATFORM_CONFIG";
export const POS_PLATFORM_ERROR = "POS_PLATFORM_ERROR";
export const POS_CATEGORIES = "POS_CATEGORIES";
export const POS_ITEMS = "POS_ITEMS";
export const POS_ITEMS_APPEND = "POS_ITEMS_APPEND";
export const POS_TOP_ITEMS = "POS_TOP_ITEMS";
export const POS_CATALOG_LOADING = "POS_CATALOG_LOADING";
export const POS_PLATFORM_RESET = "POS_PLATFORM_RESET";
export const POS_SEARCH_LOADING = "POS_SEARCH_LOADING";
export const POS_SEARCH_RESULTS = "POS_SEARCH_RESULTS";
export const POS_SEARCH_CLEAR = "POS_SEARCH_CLEAR";
